import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faCheck } from "@fortawesome/pro-light-svg-icons"
import { GetCesionByFiltersDtoProps } from "api/DTOs/GetCesionByFiltersDto"
import { ESTADO_CESION } from "api/Types/EstadoCesion"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"
import { EstadoRevisionActual } from "../components/EstadoRevisionActual"

export const CESIONES_COLUMNS = ({
  t,
  handleModal,
  isContactoPage = false,
}: {
  t: TFunction
  handleModal: (rowData: GetCesionByFiltersDtoProps) => void
  isContactoPage?: boolean
}) => {
  const columns = [
    {
      header: t("validaciones.cesiones.table.columns.financiera"),
      field: "empresaInternaRazonSocial",
      key: "financiera",

      width: "15%",
      sortable: true,
      sortField: "empresaInternaRazonSocial",
    },
    isContactoPage
      ? {}
      : {
          header: t("validaciones.cesiones.table.columns.razonSocial"),
          field: "librador.razonSocial",
          key: "razonSocial",
          sortable: true,
          sortField: "librador.razonSocial",
        },
    isContactoPage
      ? {}
      : {
          header: t("validaciones.cesiones.table.columns.nif"),
          field: "librador.nif",
          key: "cif",
          style: { width: "10%" },
          sortable: true,
          sortField: "librador.nif",
        },
    {
      header: t("validaciones.cesiones.table.columns.fechaContrato"),
      field: "fechaInicioContrato",
      key: "fechaInicioContrato",
      style: { width: "10%" },
      body: ({ fechaInicioContrato }: GetCesionByFiltersDtoProps) =>
        fechaInicioContrato
          ? frontendDateFormat(new Date(fechaInicioContrato))
          : "",
      sortable: true,
      sortField: "fechaInicioContrato",
    },
    {
      header: t("validaciones.cesiones.table.columns.estado"),
      field: "estado",
      key: "estado",
      style: { width: "10%" },
      body: EstadoRevisionActual,
      alignCol: "center",
      sortable: true,
      sortField: "estado",
    },
    {
      header: t("validaciones.cesiones.table.columns.descripcion"),
      field: "descripcion",
      key: "descripcion",
      style: { width: "30%" },
      sortable: true,
      sortField: "descripcion",
    },

    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      body: (rowData: GetCesionByFiltersDtoProps) => {
        if (!rowData.id) return
        const optionDisabled = !(
          ESTADO_CESION.CREADA === rowData.estado ||
          ESTADO_CESION.COMUNICADA === rowData.estado
        )
        return (
          <OptionsMenuStorybook
            id={rowData.id}
            items={[
              {
                title: `${t("validaciones.checkLabelMobile.acceptCesion")}`,
                hasRedirect: true,
                action: () => {
                  rowData?.id && handleModal(rowData)
                },
                disabled: optionDisabled,
                icon: faCheck,
              },
            ]}
            position='right'
            disabled={optionDisabled}
          />
        )
      },
    },
  ]
  return columns
}
